export default __webpack_public_path__ + "static/logoWhite-927c50f9edd638abfd2cb23d04ccaee2.svg";